"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCardType = void 0;
var BaseCardType;
(function (BaseCardType) {
    BaseCardType["DEFAULT"] = "default";
    BaseCardType["DTVNOWBASE"] = "dtvnowbase";
    BaseCardType["DTVNOWPREMIUM"] = "dtvnowpremium";
    BaseCardType["DTVNOWHARDWARE"] = "dtvnowhardware";
    BaseCardType["DTVNOWCDVR"] = "dtvnowcdvr";
    BaseCardType["DTVNOWSTREAM"] = "dtvnowstream";
    BaseCardType["WIRELESSDEVICE"] = "wirelessdevice";
})(BaseCardType = exports.BaseCardType || (exports.BaseCardType = {}));
//# sourceMappingURL=BaseCardProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/BaseCard/BaseCardProps.js
// module id = 462
// module chunks = 8